import script from "./Institution.vue?vue&type=script&setup=true&lang=js"
export * from "./Institution.vue?vue&type=script&setup=true&lang=js"

import "./Institution.vue?vue&type=style&index=0&id=101cbeb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-101cbeb0"]])

export default __exports__